import { MediaUpload } from "@business-finland/wif-ui-lib";
import { useTranslation } from "next-i18next";
import { useCallback } from "react";

import CompanyFieldset from "./Fieldset";
import { companyFormDefaultText } from "../constants";
import { useCompanyFormDispatch, companyFormActions, useCompanyFormState } from "../store";
import type { CompanyFormUploadFieldProps } from "../types";

const ONE_MB_IN_BYTES = 1024 * 1024;
const supportedMimeTypes = ["image/jpeg", "image/png"];

export default function CompanyLogo({
  heading,
  leadText = companyFormDefaultText.companyLogoLeadText,
  uploadAreaCaption = companyFormDefaultText.companyLogoUploadAreaCaption,
  unsupportedFileTypeErrorMessage,
}: Partial<CompanyFormUploadFieldProps> & {
  heading: string;
  unsupportedFileTypeErrorMessage: string;
}): JSX.Element {
  const dispatch = useCompanyFormDispatch();
  const { companyLogo } = useCompanyFormState();
  const { t } = useTranslation();

  const handleFileChange = useCallback(
    (file: File | undefined) => {
      dispatch(companyFormActions.setValue({ companyLogo: file }));
    },
    [dispatch]
  );

  return (
    <CompanyFieldset id="logo" heading={heading}>
      <p>{leadText}</p>

      <MediaUpload
        name={"companyLogo"}
        caption={uploadAreaCaption}
        value={companyLogo}
        onChange={handleFileChange}
        maxFileSize={ONE_MB_IN_BYTES}
        supportedMimeTypes={supportedMimeTypes}
        i18n={{
          browseFilesLabel: t("form.browseFiles"),
          maximumSizeLabel: t("form.maximumSize"),
          optionalLabel: t("form.optional"),
          unsupportedFileTypeError: unsupportedFileTypeErrorMessage,
        }}
      />
    </CompanyFieldset>
  );
}
